import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { JobFile } from "@/types";

/**
 * This hook is used to add a new job file to the job files query
 * without refetching the entire query.
 */
export const useAddJobFile = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ jobFileToAdd }: { jobFileToAdd: JobFile }) => {
    queryClient.setQueryData(
      ["files", currentCompanyId, currentJobId],
      (cachedData: JobFile[]) => {
        // Important to add the new job file to the top of the list.
        return [jobFileToAdd, ...cachedData];
      },
    );
  };
};
